"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _formatters = require("../../../utils/formatters");
require("./ContactData.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ContactData = function ContactData(_ref) {
  var image = _ref.image,
    name = _ref.name,
    account = _ref.account;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-contact-data"
  }, image, account ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-contact-account"
  }, /*#__PURE__*/_react["default"].createElement("p", null, name), /*#__PURE__*/_react["default"].createElement("span", null, (0, _formatters.formatAccount)(account))) : name && /*#__PURE__*/_react["default"].createElement("h6", null, name));
};
var _default = exports["default"] = ContactData;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/common/ContactData/ContactData.js
// module id = 593
// module chunks = 0